import { BusinessPartner } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';

/**
 * 0461. 取引先詳細
 * [GET] /workspaces/:identifier/business_partners/:id
 */
type Props = {
  identifier: string;
  id: number;
}

const businessPartner = (props: Props): Promise<BusinessPartner> => {
  return axios.get(`/api/workspaces/${props.identifier}/business_partners/${props.id}`);
};

export const useBusinessPartner = (props: Props) => {
  return useQuery({
    queryKey: ['workspaces', props.identifier, 'business_partners', props.id],
    queryFn: () => businessPartner(props),
  });
};
